<template>
    <div v-for="value in props.data">
        <div class="team-row">
            <span class="team-name" >{{ value.teamName }}</span>
            <div>
                <DxButton hint="Expand team details - not implmentd" icon="spindown" styling-mode="contained" type="normal" disabled="true" />
                <DxButton hint="Download report - not implemented" icon="download" styling-mode="contained" type="normal" disabled="true" />                
            </div>       
        </div>    
        <hr/>
    </div>                        
</template>

<script lang="ts" setup>
import { DxButton } from 'devextreme-vue';
import { ServiceTeamItem } from '@/services/entities/ServiceTeams/ServiceTeamItem';

const props = defineProps({
    data: {Type: [] as ServiceTeamItem[], default: [] as ServiceTeamItem[]},
});

</script>
<style scoped lang="scss">
.team-row {
    margin-top: 8px;
    font-weight: normal;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
.team-name {
    display: block;
    padding-top: 8px;
}

</style>    